import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";

export function useAssignServiceTeamAction(clientId, onDone = () => {}) {
  const mutationFactory = useCallback(() => {
    const query = `mutation assignServiceTeam($clientId: ID!, $serviceTeamId: ID) {
        assignServiceTeam(clientId: $clientId, serviceTeamId: $serviceTeamId) {
          serviceTeam {
            id
          }
        }                    
      }
  `;

    const resolver = ({ data: { assignServiceTeam: serviceTeam }, errors }) => {
      if (errors && errors.length) {
        return { errors: errors };
      }

      return serviceTeam;
    };

    return { query, resolver };
  }, []);

  const [assignServiceTeam, { loading: isAssigning }] = useMutationWithToaster(
    mutationFactory,
    { onDone: useCallback(onDone, []) }
  );

  return {
    assignServiceTeam: (serviceTeamId) => {
      return assignServiceTeam(
        {
          clientId: toGlobalId("Client", clientId),
          serviceTeamId: serviceTeamId,
        },
        {
          successMsg: "Service Team successfully updated.",
          defaultErrorMsg: "Failed to update Service Team.",
        }
      );
    },
    isAssigning: isAssigning,
  };
}

export default useAssignServiceTeamAction;
